import Vue from 'vue'
import Vuex from 'vuex'
import VueFuse from 'vue-fuse'
import vmodal from 'vue-js-modal'
import VueClipboard from 'vue-clipboard2'
import Paginate from 'vuejs-paginate'
import VueApexCharts from 'vue-apexcharts'
import { sync } from 'vuex-router-sync'
import { appData, ruleHelpers } from '@/utils'

import '@/components'
import '@/plugins'

import App from './App.vue'
import PluginBanner from './components/core/PluginBanner'
import store from './store'
import router from './router'

Vue.use(VueFuse)
Vue.use(Vuex)
Vue.use(vmodal)
Vue.use(VueClipboard)
Vue.component('paginate', Paginate)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

if (appData.get('pluginPath')) {
	/* eslint-disable */
	__webpack_public_path__ = appData.get('pluginPath') + 'vue/dist/'
	/* eslint-enable */
}

// Sync store with router
sync(store, router)

Vue.config.productionTip = false

// Store router for easy access.
appData.set('$router', router)

const main = new Vue({
	el     : '#om-app',
	store,
	router,
	render : h => h(App),
})

main.$el.classList.remove('om-circle-loading')

main.$bus.$on('badCredentials', () => store.commit('apiKeyValid', false))

// Set the main app key.
appData.appKey = 'main'

// Store App in our global.
appData.setApp(main)

// Store PluginBanner app in our global.
appData.setApp(new Vue({
	el     : '#omwp-plugin-banner',
	store,
	router,
	render : h => h(PluginBanner),
}), 'banner')

// Setup a fallback data object.
appData.set('rulesetData', ruleHelpers.setup(ruleHelpers.defaultData))

// If we're on one of our query routes...
const route = router.getRouteForQuery()
if (route) {
	if (window.location.hash) {
		route.hash = window.location.hash
	}

	// Then trigger the route
	router.replace(route)
}

// Signal that our app is ready.
appData.ready()
